import { useEffect, useRef, useState } from "react";
import NiceModal from "@ebay/nice-modal-react";
import OverlayMenuBase from "modals/base/OverlayMenuBase";
import style from "./LiquidSideMenu.module.css";
import MenuGroup from "routes/MenuGroup";
import { brands } from "data/brands";

const LiquidSideMenu = NiceModal.create(
    (props, ref) => {
        const modal = useRef();
        const [withHeader, withFooter] = [true, false];
        const [width, height] = ["min(80%, 500px)", "100dvh"];
        const withCloseButton = true;
        const clickOutsideToClose = true;
        const menus = [
            {
                id: 1,
                type: "group",
                title: "브랜드",
                icon: "faFlask",
                children: brands
            }
        ]

        return (
            <OverlayMenuBase ref={modal} width={width} height={height} withHeader={withHeader} withCloseButton={withCloseButton} clickOutsideToClose={clickOutsideToClose} >
                <div className={style.menu}>
                    <div className={style.menuList}>
                        {
                            menus.map((menu) => {
                                if (menu.type === "group") {
                                    return <MenuGroup key={menu.id} data={menu} />;
                                } else if (menu.type === "item") {

                                }
                            })
                        }
                    </div>
                </div>
            </OverlayMenuBase>
        );
    }
);

export default LiquidSideMenu;
